module.exports = __webpack_public_path__ + "da70224dab6157ce6ef59af2b6742e08.svg";